module.exports = __webpack_public_path__ + "img/email-2.6da8c8cd.jpg";